import React from 'react'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import CDInput from 'components/cd-input'
import TextArea from 'components/text-area'
import CDButton from 'components/cd-button'
import NativeSelect from '../components/native-select'
import { branchesApi } from '../restaurant.api'
import { useBranches } from './branches.context'

const STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
]

const validationSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  address: Yup.string().required('Address is required'),
  contactNumber: Yup.string().required('Contact number is required'),
})

const toInitialValues = (branch) => ({
  name: branch?.name || '',
  address: branch?.address || '',
  contactNumber: branch?.contactNumber || '',
  workingHours: branch?.workingHours || '',
  mapEmbedUrl: branch?.mapEmbedUrl || '',
  status: branch?.status || 'active',
})

function BranchForm({ branch, onClose }) {
  const { refresh } = useBranches()
  const isEditing = !!branch?._id

  const handleSubmit = async (values, { setSubmitting }) => {
    const { response } = isEditing
      ? await branchesApi.update(branch._id, values)
      : await branchesApi.create(values)

    setSubmitting(false)
    if (response?.success) {
      await refresh()
      onClose()
    }
  }

  return (
    <Formik
      initialValues={toInitialValues(branch)}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formik) => (
        <Form className='tw-flex tw-flex-col tw-gap-4'>
          <CDInput name='name' label='Branch name' required />
          <TextArea name='address' label='Address' required />
          <CDInput name='contactNumber' label='Contact number' required />
          <CDInput name='workingHours' label='Working hours' placeholder='9:00 AM - 11:00 PM' />
          <TextArea name='mapEmbedUrl' label='Google Maps embed URL' />
          <NativeSelect name='status' label='Status' options={STATUS_OPTIONS} />

          <div className='tw-flex tw-gap-3 tw-mt-2'>
            <CDButton
              type='submit'
              processing={formik.isSubmitting}
              label={isEditing ? 'Save changes' : 'Create branch'}
            />
            <button
              type='button'
              onClick={onClose}
              className='tw-px-[24px] tw-py-[8px] tw-rounded-[6px] tw-border tw-border-gray-300 tw-text-gray-600 tw-text-regular'
            >
              Cancel
            </button>
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default BranchForm
